import styles from './style.module.css';

const Divider: React.FC = () => {
	return <div className={styles.divider} />;
};

export default Divider;
